"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _KYCConfirmLevelModal = _interopRequireDefault(require("../../KYC/KYCConfirmLevelModal"));
var _KYC_ManualDirectionsComponent = _interopRequireDefault(require("./KYC_ManualDirectionsComponent"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _formGeneratorHelper = require("../../../helpers/formGeneratorHelper");
var _kycFormHelper = require("../../../helpers/kycFormHelper");
var _KYC_ManualHelpers = require("../KYC_ManualHelpers");
var _kycConfigShapePropTypes = require("../../../propTypes/kycConfigShapePropTypes");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var slidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('slide-pane');
var KYC_ManualFormComponent = /*#__PURE__*/function (_React$Component) {
  function KYC_ManualFormComponent(props) {
    var _this;
    _classCallCheck(this, KYC_ManualFormComponent);
    _this = _callSuper(this, KYC_ManualFormComponent, [props]);
    _defineProperty(_this, "openModal", function (isOpen) {
      return _this.setState({
        isOpen: isOpen
      });
    });
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inherits(KYC_ManualFormComponent, _React$Component);
  return _createClass(KYC_ManualFormComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _kycFormHelper.setDropdownsDefaultValue)(this.props.level.sections, this.props.change);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var _this$props = this.props,
        level = _this$props.level,
        closeSidePane = _this$props.closeSidePane,
        formValues = _this$props.formValues,
        processing = _this$props.processing,
        customClass = _this$props.customClass;
      var baseClasses = (0, _cssClassesHelper.getBEMClasses)('kyc-form', customClass);
      var manualDirections = level.manualDirections;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("form", {
        className: (0, _classnames["default"])('form-inline', slidePaneClasses('body'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-body')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('title')
      }, t(level.sections[0].title || 'Complete this form to verify your account to raise your limits and enable buys.')), level && level.sections.map(function (section, idx) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClasses('section'),
          key: idx
        }, /*#__PURE__*/_react["default"].createElement("header", {
          className: baseClasses('section-header')
        }, /*#__PURE__*/_react["default"].createElement("p", {
          className: "text-white"
        }, t(section.label))), /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClasses('section-body')
        }, manualDirections ? /*#__PURE__*/_react["default"].createElement(_KYC_ManualDirectionsComponent["default"], {
          section: section
        }) : (0, _formGeneratorHelper.renderFormInputs)(section.form, baseClasses(), {
          t: t
        })));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('section')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        type: "button",
        customClass: baseClasses(),
        onClick: manualDirections ? function () {
          return closeSidePane();
        } : function () {
          return _this2.openModal(true);
        }
      }, t(manualDirections ? 'Close' : 'Submit'))))), !manualDirections && /*#__PURE__*/_react["default"].createElement(_KYCConfirmLevelModal["default"], {
        isOpen: this.state.isOpen,
        close: function close() {
          return _this2.openModal(false);
        },
        onConfirm: function onConfirm() {
          return (0, _KYC_ManualHelpers.submitManualForm)(_this2.props);
        },
        processing: processing,
        level: level,
        values: formValues
      }));
    }
  }]);
}(_react["default"].Component);
KYC_ManualFormComponent.propTypes = {
  kycConfig: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    levels: _propTypes["default"].arrayOf(_propTypes["default"].shape(_kycConfigShapePropTypes.kycConfigLevelShape))
  })
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('kyc')(KYC_ManualFormComponent);